export const CUSTOMER_SERVICE_FORM_SUBMIT = 'waitrose/customerService/CUSTOMER_SERVICE_FORM_SUBMIT';
export const CUSTOMER_SERVICE_FORM_SUBMIT_FAIL =
  'waitrose/customerService/CUSTOMER_SERVICE_FORM_SUBMIT_FAILED';
export const CUSTOMER_SERVICE_FORM_SUBMIT_SUCCESS =
  'waitrose/customerService/CUSTOMER_SERVICE_FORM_SUBMIT_SUCCESS';

export const CUSTOMER_SERVICE_FORM_ACTIONS = [
  CUSTOMER_SERVICE_FORM_SUBMIT,
  CUSTOMER_SERVICE_FORM_SUBMIT_SUCCESS,
  CUSTOMER_SERVICE_FORM_SUBMIT_FAIL,
] as const;
